import React, { FunctionComponent } from 'react'

import { CalendrierUniversel } from '../../components/CalendrierUniversel';

import { CalendrierProps } from './Calendrier.types'

export const Calendrier: FunctionComponent<CalendrierProps> = ({ navigation, route }) => {
  const {mode, value} = route.params || {};
  const handleAddAbsence = () => {    
    if (navigation) {
      try {
        navigation.navigate('NouvelleDemande');
      } catch (error) {
        console.error('❌ Erreur de navigation:', error);
      }
    } else {
      console.error('❌ Navigation non disponible');
    }
  };

  return (
    <CalendrierUniversel 
      onAddAbsence={handleAddAbsence}
      navigation={navigation}
      mode={mode}
      value={value}
    />
  )
}

